export default {
    app_name: 'Bookeraj',

    microcopy: {
        add: 'Add',
        add_plus: '+ Add',
        back: 'Back',
        ok: 'Ok',
        remove: 'Remove',
        next: 'Next',
        complete: 'Complete',
        close: 'Close',
        continue: 'Continue',
        cancel: 'Cancel',
        confirm: 'Confirm',
        new: 'New',
        save: 'Save',
        created: 'Created',
        success: 'Success',
        none: 'None',
        category: 'Category',
        delete: 'Delete',
        edit: 'Edit',
        accept: 'Accept',
        decline: 'Decline',
        from: 'from',
        to: 'to',
        extend: 'Extend',
        apply: 'Apply',
        show_more: 'Show more',
        show_all: 'Show all',
        details: 'more details',
        select: 'Select',
        view: 'View',
        all: 'All',
        company: 'Company',
        companies: 'Companies',
        in: 'in',
        account: 'Account',
        book: 'Book',
        respond: 'Respond',
        open: 'Open',
        by: 'by',
        check_availability: 'Check availability',
        reviews: 'Number of reviews: {n}',
        view_number: 'Views: {n}',
        favorites: 'Favorites',
        about: 'About',
        about_us: 'About us',
        meet_the_team: 'Meet the team',
        our_team: 'Our team',
        contact_us: 'Contact Us',
        email: 'Email',
        phone: 'Phone',
        go_to_profile: 'Go to profile',
        [true]: 'Yes',
        [false]: 'No',
        done: 'Done',
        description: 'Description',
        you: 'You',
        invite: 'Invite',
        check: 'Check',
        date: 'Date',
        and: 'and',
        soldout: 'SOLD OUT',
        unavailable: 'UNAVAILABLE',
        reset: 'Reset',
        total_price: 'Total price:',
        total_time: 'Total time:',
        choose_time: 'Choose time',
        copied: 'Copied',
        copy: 'Copy',
        share: 'Share',
        reload: 'Reload',
        flexible: 'Flexible',
        day: 'Daily',
        month: 'Monthly',
        send_sms: 'Send sms',
        key: 'Key',
        value: 'Value',
        no_results: 'No results',
        language: 'Language',
        view_details: 'View details',
        preview_daily_schedule: 'Preview daily schedule',
        free_reservation: 'Free reservation',
        hours: 'Hours',
        minutes: 'Minutes',
        protected: 'protected',
        download_pdf: 'Download pdf',
        note: 'Note',
        note_reservation: 'Note for reservation',
        i_want: 'I want',
        dont_want: 'I don`t want',
        current_price: 'Current price:',
        suggested_parking: 'Suggested parking spot',
        activate: 'Activate',
        admin: 'Admin',
        daily: 'Daily',
        weekly: 'Weekly',
        montly: 'Montly',
    },

    calendar: {
        today: 'Today',
        slots: '1 slot | {n} slots',
    },

    general: {
        not_saved: 'Current changes are not saved. Do you want to save them?',
    },

    days: {
        mon: { short: 'Mon', long: 'Monday' },
        tue: { short: 'Tue', long: 'Tuesday' },
        wed: { short: 'Wed', long: 'Wednesday' },
        thu: { short: 'Thu', long: 'Thursday' },
        fri: { short: 'Fri', long: 'Friday' },
        sat: { short: 'Sat', long: 'Saturday' },
        sun: { short: 'Sun', long: 'Sunday' },
    },

    months: {
        0: { short: 'Jan', long: 'January' },
        1: { short: 'Feb', long: 'February' },
        2: { short: 'Mar', long: 'March' },
        3: { short: 'Apr', long: 'April' },
        4: { short: 'May', long: 'May' },
        5: { short: 'Jun', long: 'June' },
        6: { short: 'Jul', long: 'July' },
        7: { short: 'Aug', long: 'August' },
        8: { short: 'Sep', long: 'September' },
        9: { short: 'Oct', long: 'October' },
        10: { short: 'Nov', long: 'November' },
        11: { short: 'Dec', long: 'December' },
    },

    errors: {
        common_error: 'Something went wrong',
        invalid_image: 'Image is not valid',
        wait_for_upload_complete: 'Please wait for the current upload to finish',
        location_required: 'To create service please add location!',
        wrong_subdomain:
            'Company with given subdomain does not exist. In case subdomain is changed try to find it on bookeraj application',
    },
}
